<!-- @TODO -->
<!-- [class.component-dark-theme]="themeService.isDark()"
  [class.rtl-enabled]="themeService.isRTLEnabled()" -->
<!-- d-block -->
<mat-card
  class="daxa-card  h-100 border-radius border-none mb-20"

>
  <mat-card-header class="mb-0">
    <mat-card-title>
      <h6 class="mb-0">
        {{ drawing().team?.label }}
      </h6>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content
    class="d-flex"
    style="flex-grow: 1; flex-direction: column; justify-content: flex-end; margin-bottom: 20px;"
  >
    <div class="d-flex justify-content-between">
      <div class="content d-flex justify-content-between">
        <!-- @TODO: descomentar y arreglar -->
        <!-- @if (drawing.player?.eventRank) {
          <div class="price lh-1 fw-medium">
            <span class="text-body">#</span>{{ drawing.player?.eventRank }}
          </div>
        } -->
        <!-- <a routerLink="/ecommerce-page/seller-details" class="link-btn d-inline-block fw-medium text-decoration-underline">
          Ver
        </a> -->

        @if (drawing().isSeed) {
          <div
            matTooltip="Siembra"
            matTooltipPosition="above"
            class="icon rounded-circle position-relative text-daxa text-center"
          >
            <i class="material-symbols-outlined" style="color: #008000;">psychiatry</i>
          </div>
        }
      </div>

      <div class="image">
        <img
          [ngSrc]="bucketUrl + '/images/avatars/' + drawing().avatarImg"
          width="100"
          height="100"
          alt="man-image"
          style="max-height: 100px;"
        />
      </div>
    </div>
  </mat-card-content>
</mat-card>
